export default __webpack_public_path__ + "static/media/purchase-order.5cf70d4c.svg";